import { useState } from "react";
import styled from "styled-components";
import Utils from "../../../../Utils";
import { themeVariables } from "src/themeVariables";

const SummaryBoxContainer = styled.div`
  margin-top: 3px;
  width: calc(100% - 40px);
  text-align: left;
  padding-right: 8px;
  color: var(--grey-1);
  font-style: italic;
  font-weight: 500;
  line-height: 1.3;
  padding: 20px;
  padding-top: 0px;
  .current-chapter {
    font-weight: 700;
  }
  border-bottom: 1px solid ${themeVariables.divider};

  .show-hide-summary {
    font-weight: 500;
    font-style: underline;
    border-bottom: 1px solid;
    cursor: pointer;
  }
`;

function SummaryBox({ sceneSummary = "", sceneToWrite }) {
  const [truncate, setTruncate] = useState(true);
  const truncateLength = 180;
  const truncatedSummary = sceneSummary.slice(0, truncateLength);
  return (
    <SummaryBoxContainer>
      <span className="current-chapter">{sceneToWrite.label}: </span>
      <span
        tabIndex={0}
        aria-label={`Selected Scene Summary: ${sceneSummary}`}
      >
        {truncate ? truncatedSummary : Utils.nl2br(sceneSummary)}
        {sceneSummary.length > truncateLength && (
          <>
            <span>{truncate ? "... " : ""}</span>
            <span
              className="show-hide-summary"
              onClick={() => setTruncate(!truncate)}
            >
              {truncate ? "show more" : "  show less"}
            </span>
          </>
        )}
      </span>
    </SummaryBoxContainer>
  );
}

export default SummaryBox;
